import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

export const APP_STORE_URL = 'https://apps.apple.com/eg/app/flea-market/id6777736501';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.flea.marketplace';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: ${(p) => (p.$align === 'start' ? 'flex-start' : 'center')};
`;

const StoreButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 52px;
  padding: 0.6rem 1.25rem;
  border-radius: 0.75rem;
  background: #000;
  color: #fff !important;
  font-weight: 600;
  font-size: 0.82rem;
  line-height: 1.2;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  &:hover {
    background: #1a1a1a;
    color: #fff !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  }

  @media (max-width: 768px) {
    min-height: 46px;
    padding: 0.5rem 1rem;
    font-size: 0.78rem;
  }
`;

const StoreIcon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 22px;
    height: 22px;

    @media (max-width: 768px) {
      width: 20px;
      height: 20px;
    }
  }
`;

const StoreLabel = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.1;
`;

const SmallLabel = styled.span`
  font-size: 0.55rem;
  font-weight: 400;
  opacity: 0.8;
  letter-spacing: 0.02em;

  @media (max-width: 768px) {
    font-size: 0.5rem;
  }
`;

const MainLabel = styled.span`
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: -0.01em;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
    </svg>
  );
}

function PlayIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.807 1.626a1 1 0 0 1 0 1.732l-2.807 1.626L15.206 12l2.492-2.492zM5.864 2.658L16.8 9.09l-2.302 2.302-8.634-8.734z" />
    </svg>
  );
}

export default function AppStoreButtons({ align = 'center' }) {
  const { t } = useTranslation();

  return (
    <Row $align={align}>
      <StoreButton
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('home.downloadFromAppStore')}
      >
        <StoreIcon><AppleIcon /></StoreIcon>
        <StoreLabel>
          <SmallLabel>Download on the</SmallLabel>
          <MainLabel>App Store</MainLabel>
        </StoreLabel>
      </StoreButton>
      <StoreButton
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('home.downloadFromGooglePlay')}
      >
        <StoreIcon><PlayIcon /></StoreIcon>
        <StoreLabel>
          <SmallLabel>Get it on</SmallLabel>
          <MainLabel>Google Play</MainLabel>
        </StoreLabel>
      </StoreButton>
    </Row>
  );
}
